export default "__VITE_ASSET__j4MQ14C5__"